import { z } from 'zod';

// Zod counterparts of TYesNo / TYesNoUnknown (@/types/form-values). Using z.enum rather
// than z.string() keeps the resolver's inferred type equal to the union on the form
// values interface, which is what makes a stale comparison a compile error.

/** '1' = yes, '0' = no, '' = unanswered. */
export const yesNo = z.enum(['1', '0', '']);

/** As yesNo, but leaving it unanswered is an error. */
export const yesNoRequired = yesNo.refine((value) => value !== '', { message: 'Required' });

/** Adds Unknown = '-1'. */
export const yesNoUnknown = z.enum(['1', '0', '-1', '']);

/** As yesNoUnknown, but leaving it unanswered is an error. */
export const yesNoUnknownRequired = yesNoUnknown.refine((value) => value !== '', {
    message: 'Required',
});

interface IRefinementIssues {
    addIssue: (issue: { code: 'custom'; path: (string | number)[]; message: string }) => void;
}

/**
 * For use inside `superRefine`: flags each named field that is blank as Required. Lets a
 * schema express "these fields are required when that answer is Yes" in one line.
 */
export const requireFields = <T extends object>(ctx: IRefinementIssues, data: T, ...fields: (keyof T & string)[]) => {
    for (const field of fields) {
        if (!data[field]) {
            ctx.addIssue({ code: 'custom', path: [field], message: 'Required' });
        }
    }
};
